import { defineStore } from 'pinia'
import { toRefs } from "vue";

export const useHeaderStore = defineStore('header', {
  state: () => {
    return {
      toggleMobileMenu: false,
      toggleMobileSearch: false,
      searchTitleType: '사업자 등록 번호'
    }
  },

  actions: {
    setSearchTitleType(text) {
      this.searchTitleType = text;
    },
    close() {
      this.toggleMobileMenu = false;
      this.toggleMobileSearch = false;
      window.document.querySelector('.dim.active')?.remove();
      this.createDim()
    },
    createDim() {
      const self = this;
      if (self.toggleMobileMenu || self.toggleMobileSearch) {
        const dimDiv = window.document.createElement('div')
        dimDiv.setAttribute('class', 'dim active')
        dimDiv.addEventListener('pointerup', function () {
          self.toggleMobileMenu = false;
          self.toggleMobileSearch = false;
          dimDiv?.remove()
        })
        window.document.body.appendChild(dimDiv)
      } else {
        window.document.querySelector('.dim.active')?.remove();
      }
    },
    toggleMobileSearchEvent() {
      this.toggleMobileMenu = false;
      window.document.querySelector('.dim.active')?.remove();
      this.toggleMobileSearch = !this.toggleMobileSearch;
      this.createDim()
    },
    toggleMobileMenuEvent() {
      this.toggleMobileSearch = false;
      window.document.querySelector('.dim.active')?.remove();
      this.toggleMobileMenu = !this.toggleMobileMenu;
      this.createDim()
    }
  }
})